import { useEffect, useState } from "react";
import AppShell from "../../components/AppShell";
import { PageHeader, Panel } from "../../components/Bits";
import StudentAvatar from "../../components/StudentAvatar";
import { api } from "../../lib/api";

export default function StudentProfile() {
  const [me, setMe] = useState(null);
  useEffect(() => { api.get("/students/me").then((r) => setMe(r.data)).catch(() => {}); }, []);

  if (!me) return <AppShell><div className="text-sm text-warm">Loading…</div></AppShell>;

  const rows = [
    ["Admission no.", me.admission_no],
    ["Full name", me.name],
    ["Email", me.email],
    ["Date of birth", me.dob],
    ["Age", me.age],
    ["Aadhaar number", me.aadhar_number],
    ["Mobile", me.mobile],
    ["Parents' mobile", me.parents_mobile],
    ["Emergency contact", me.emergency_contact || "—"],
    ["Blood group", me.blood_group || "—"],
    ["Course", me.course],
    ["College", me.college],
    ["Room number", me.room_number || "—"],
    ["Bed number", me.bed_number || "—"],
    ["Joining date", me.joining_date],
    ["Monthly rent", me.monthly_rent != null ? `₹ ${me.monthly_rent}` : "—"],
    ["Security deposit", me.security_deposit != null ? `₹ ${me.security_deposit}` : "—"],
  ];

  const guardianRows = [
    ["Guardian name", me.local_guardian_name],
    ["Guardian mobile", me.local_guardian_mobile],
    ["Relation", me.local_guardian_relation],
    ["Guardian address", me.local_guardian_address],
  ];

  return (
    <AppShell>
      <PageHeader overline="My information" title="Profile" subtitle="If anything looks wrong, please reach out to the warden." />
      <Panel className="max-w-3xl">
        <div className="flex items-center gap-4 mb-6">
          <StudentAvatar student={me} size={72} />
          <div>
            <div className="font-heading text-3xl text-deep leading-none">{me.name}</div>
            <div className="text-warm text-sm mt-1">{me.course} · {me.college}</div>
          </div>
        </div>
        <dl className="grid sm:grid-cols-2 gap-x-6 gap-y-4">
          {rows.map(([k, v]) => (
            <div key={k}>
              <dt className="text-xs uppercase tracking-wider text-warm">{k}</dt>
              <dd className="text-deep mt-1">{v ?? "—"}</dd>
            </div>
          ))}
          <div className="sm:col-span-2">
            <dt className="text-xs uppercase tracking-wider text-warm">Permanent address</dt>
            <dd className="text-deep mt-1 whitespace-pre-wrap">{me.permanent_address}</dd>
          </div>
        </dl>

        <div className="mt-8 pt-6 border-t border-warm">
          <div className="text-xs uppercase tracking-wider text-warm mb-3">Local guardian</div>
          <dl className="grid sm:grid-cols-2 gap-x-6 gap-y-4">
            {guardianRows.map(([k, v]) => (
              <div key={k}>
                <dt className="text-xs uppercase tracking-wider text-warm">{k}</dt>
                <dd className="text-deep mt-1">{v || "—"}</dd>
              </div>
            ))}
          </dl>
        </div>

        {me.tnc_accepted_at && (
          <div className="mt-8 pt-6 border-t border-warm">
            <div className="text-xs uppercase tracking-wider text-warm mb-1">Terms &amp; Conditions</div>
            <div className="text-sm text-deep">
              Accepted on {new Date(me.tnc_accepted_at).toLocaleString()}
            </div>
          </div>
        )}
      </Panel>
    </AppShell>
  );
}
